// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"a26f8299","946":"9f62d557"}[chunkId] + ".chunk.js";
};